import Vue from "vue";
import Vuex from "vuex";
import loginStore from "./loginStore";
import printx from "./printxStore";
import { Conf } from "../conf/defaults";
import axios from "axios";
import router from "../router";
import { Utils, getFriendlyErrorMessage } from "./common/utils";
//import createPersistedState from 'vuex-persistedstate'
//import * as Cookies from 'js-cookie'
import VuexPersist from "vuex-persist";
import notification from "./modules/notification"

Vue.use(Vuex);
/* eslint-disable */

const vuexPersist = new VuexPersist({
  key: "vuex", // The key to store the state on in the storage provider.
  storage: window.localStorage // or window.sessionStorage or localForage
  //storage: window.sessionStorage,
  // Function that passes the state and returns the state with only the objects you want to store.
  // reducer: state => state,
  // Function that passes a mutation and lets you decide if it should update the state in localStorage.
  // filter: mutation => (true)
});

export const store = new Vuex.Store({
  modules: {
    login: loginStore,
    printx,
    notification
  },
  state: {
    tipoaccount: "", // ADMIN or USER
    currentState: "", // DOC or TICKET
    currentLeftMenu: [],
    //StampaLottoInterno
    //stampaLI_DOTes: null,     //CURRENT DO_Tes, if not set button is disabled
    //stampaLI_Saved: false,    //if current DO_Tes is saved or not
    //Error Message
    error: null,
    errorMessage: null,
    //Work in progress Dialog
    dialogMessage: null,
    //Messages not in a dialog but inside the window
    progressMessage: null,
    //lottoInterno,
    lottoInterno: null,
    //UUID
    uuid: null,
    //BreadCrumbItems
    breadcrumbItems: [],
    //Se true mostra unn icona di caricamento, se false mostra un spunta id successo
    progressLoading: true,
    //Se true salta il controllo della modifica delle ore
    abilitatazioneModificaOre:false,
  },
  plugins: [vuexPersist.plugin],
  mutations: {
    setUUID(state, uuid) {
      console.log("UUID >> " + uuid)
      state.uuid = uuid;
    },
    setError(state, error) {
      state.error = error;
      state.errorMessage = error.message;
    },
    setErrorMessage(state, errorMessage) {
      //console.log(errorMessage)
      state.errorMessage = errorMessage;
    },
    setDialogMessage(state, dialogMessage) {
      state.dialogMessage = dialogMessage;
    },
    setProgressMessage(state, progressMessage) {
      state.progressMessage = progressMessage;
    },
    setStatus(state, status) {
      var menuDef = new MenuDef();
      if (status == "DOC") {
        state.currentState = status;
        state.currentLeftMenu = menuDef.getMenuList(status);
        //state.currentLeftMenu = state.menuitemsDOC
      } else if (status == "TICKET") {
        state.currentState = status;
        state.currentLeftMenu = menuDef.getMenuList(status);
        //state.currentLeftMenu = state.menuitemsTICKET
      }
    },
    setBreadcrumbItems(state, breadcrumbItems) {
      // console.log("setBreadcrumbItems breadcrumbItems >> " + breadcrumbItems)
      state.breadcrumbItems = breadcrumbItems;
    },
    setLottoInterno(state, lottoInterno) {
      state.lottoInterno = lottoInterno;
    },
    setProgressLoading(state, progressLoading) {
      state.progressLoading = progressLoading
    },
    setAbilitatazioneModificaOre(state,abilitatazioneModificaOre){
      state.abilitatazioneModificaOre = abilitatazioneModificaOre
    }
  },
  actions: {

    callGenericPostMethod({
      state,
      commit,
      rootState,
      dispatch }, params) {
      var self = this;

      var ut = new Utils();

      dispatch("checkSession", {}, { root: true });

      return new Promise((resolve, reject) => {

        var urlPostRequest = Conf.idempiereUrl + params.urlMethod
        params.uuid = rootState.uuid;
        ut.axiosPost(urlPostRequest, params, resolve, reject, true)

      }).catch(e => {
        console.log("Eccezione");
        console.log(e);
        var friendlyMessage = e.friendlyMessage || getFriendlyErrorMessage(e);
        commit("setErrorMessage", friendlyMessage);
        throw e;
      });
    },

 async callIdempiereRest({
      state,
      commit,
      rootState,
      dispatch,
    }, params) {
      var self = this;

      if (params.checkSession == null || params.checkSession == 'Y') {
        await dispatch("checkSession", {}, { root: true });
      } 

      return new Promise(
        (resolve, reject) => {
          //commit("setProgressMessage", "Ricerca in corso");
          let parameters = params.data != null ? params.data : {}
          var urlPostRequest = Conf.idempiereUrl + 
            "webservices/rest/v1/" + params.idempiereRestPath;

          if (params.sendSessionUU == null || params.sendSessionUU == 'Y') {
            parameters.ad_session_uu = state.uuid;
          } 

          //console.log("2.1")
          //console.log("parameters >> " + JSON.stringify(parameters))

          axios.defaults.headers["Content-Type"] =
            "application/json;charset=utf-8";
          axios
            .post(
              urlPostRequest,
              JSON.stringify(parameters),
              {
                headers: {
                  "Content-type": "application/json;charset=utf-8",
                }
              }
            )
            .then(response => {
              //console.log("response response response >> " + JSON.stringify(response));
              resolve(response);
            })
            .catch(e => {
              console.log("Eccezione");
              console.log(e);
              console.log(e.response);
              var friendlyMessage = getFriendlyErrorMessage(e);
              commit("setErrorMessage", friendlyMessage);
              e.friendlyMessage = friendlyMessage;
              reject(e)
              //this.errors.push(e)
            });

          //commit("setProgressMessage", "Ricerca completata");
        },
        error => {
          //console.log("**** error")
          console.log("Errore");
          console.log(error);
          var friendlyMessage = getFriendlyErrorMessage(error);
          commit("setErrorMessage", friendlyMessage);
          if (error && typeof error === "object") {
            error.friendlyMessage = friendlyMessage;
          }
          reject(error);
        }
      );
    },
    //***************************************************
    //
    // Metodo generico per chiamare metodi POST
    //
    // params.urlMethod
    // params.debug
    //

    postAxiosAction({ state, commit, rootState, dispatch }, params) {
      dispatch("checkSession", {}, { root: true });
      var self = this;
      //console.log("* postAxiosAction");
      //console.log(params)
      return new Promise((resolve, reject) => {
        var urlPostRequest = Conf.idempiereUrl + params.urlMethod;
        //console.log(urlPostRequest)
        var risp = {};

        params.uuid = rootState.uuid;
        if (params.webServiceType) {
          params.webServiceType = params.webServiceType;
        }
        var listaDatiFromJson = [];
        //console.log(params.uuid)

        if (!rootState.uuid) {
          router.push({
            name: "login"
          });
        }

        axios.defaults.headers["Content-Type"] =
          "application/json;charset=utf-8";
        axios
          .post(urlPostRequest, JSON.stringify(params), {
            headers: {
              "Content-type": "application/json;charset=utf-8"
            }
          })
          .then(response => {
            if (params.debug) {
              console.log("debug response");
              console.log(response)
            }

            var listaDatiFromJson = [];

            if (response.data.data != null) {
              risp = response.data.data;

              //console.log(risp)

              for (var i in risp) {
                var riga = risp[i];
                //console.log(riga)

                var linea = {};
                for (var key in riga) {
                  if (params.debug) {
                    //console.log("key")
                    //console.log(key)
                    //console.log(riga[key].value)
                    //console.log("key %s, value %s" % (key, riga[key]))
                  }
                  linea[key] = riga[key].value;
                } //for
                listaDatiFromJson[i] = linea;
              } //for
            } else if (response.data != null) {
              risp = response.data;
              var linea = {};
              var i = 0;
              for (var key in risp) {
                //console.log("key >>> " + key)
                //console.log("value >>> " + risp[key])
                //risp[key] = risp[key].value;
                linea[key] = risp[key];
                listaDatiFromJson[i] = linea;
                i++;
              }
            }

            if (params.debug) {
              //console.log(listaDatiFromJson);
            }
            resolve(listaDatiFromJson);
          })
          .catch(error => {
            console.log("Errore");
            console.log(error);
            var friendlyMessage = getFriendlyErrorMessage(error);
            commit("setErrorMessage", friendlyMessage);
            error.friendlyMessage = friendlyMessage;
            reject(error);
          });
      }).catch(e => {
        console.log("Eccezione");
        console.log(e);
        throw e;
      });
      //commit('setProgressMessage', "Ricerca completata");
      //commit('setDialogMessage', null);
    },
    getQueryResult({ state, commit, rootState, dispatch }, params) {
      if (!rootState.uuid) {
        router.push({
          name: "login"
        });
      }
      dispatch("checkSession", {}, { root: true });
      var self = this;
      console.log("getListaClienti");
      return new Promise((resolve, reject) => {
        var urlPostRequest = Conf.idempiereUrl + "/pcli/getQueryResult";

        var parameters = {};
        parameters.uuid = rootState.uuid;
        parameters.query = params.query;
        // "SELECT AD_user.c_bpartner_id from AD_user \
        //where AD_user.Ad_user_id = "
        /*
         var fieldTypes = {}
         fieldTypes = [{
           "name": "c_bpartner_id",
           "type": "s"
         }]
 */
        parameters.fieldTypes = params.fieldTypes;

        console.log(urlPostRequest);

        axios.defaults.headers["Content-Type"] =
          "application/json;charset=utf-8";
        axios
          .post(
            urlPostRequest,
            //parameters,
            JSON.stringify(parameters), // the data to post
            {
              headers: {
                "Content-type": "application/json;charset=utf-8"
              }
            }
          )
          .then(response => {
            console.log(response);
            resolve(response);
          })
          .catch(error => {
            // http failed, let the calling function know that action did not work out
            console.log("Errore");
            console.log(error);
            var friendlyMessage = getFriendlyErrorMessage(error);
            commit("setErrorMessage", friendlyMessage);
            error.friendlyMessage = friendlyMessage;
            reject(error);
          });
      });
      //commit('setProgressMessage', "Ricerca completata");
      //commit('setDialogMessage', null);
    },
    /* https://vuejsdevelopers.com/2017/08/28/vue-js-ajax-recipes/ */
    /*
refreshMessage(context) {
 return new Promise((resolve) => {
     this.$http.get('...').then((response) => {
         context.commit('updateMessage', response.data.message);
         resolve();
     });
 });
}
*/
    //,
    generateLottoInterno(state, prgLotto, dispatch) {
      dispatch("checkSession", {}, { root: true });
      var now = new Date();
      var start = new Date(now.getFullYear(), 0, 0);
      var diff = now - start;
      var oneDay = 1000 * 60 * 60 * 24;
      var day = Math.floor(diff / oneDay);
      console.log("Day of year: " + day);
      var s = "000000000" + day;
      s = s.substr(s.length - 3);
      if (!prgLotto) prgLotto = 0;

      prgLotto = "000000000" + prgLotto;
      prgLotto = prgLotto.substr(prgLotto.length - 2);

      state.commit(
        "setLottoInterno",
        "L" + s + now.getFullYear() + prgLotto
      );
    }, //generateLottoInterno
    async schedaMese({ state, commit, rootState, dispatch }, params) {
      dispatch("checkSession", {}, { root: true });
      var self = this;

      return new Promise(
        (resolve, reject) => {
          var urlPostRequest = Conf.idempiereUrl + "/vitech/schedaMese";

          var parameters = {};
          parameters.anno = params.anno;
          parameters.mese = params.mese;
          parameters.uuid = rootState.uuid;

          axios.defaults.headers["Content-Type"] =
            "application/json;charset=utf-8";
          axios
            .post(
              urlPostRequest,
              JSON.stringify(parameters), // the data to post
              {
                headers: {
                  "Content-type": "application/json;charset=utf-8"
                }
              }
            )
            .then(response => {
              //Controllo se la sessione è valida
              //dispatch("checkSession", {}, { root: true });
              resolve(response);
            })
            .catch(e => {
              console.log("Eccezione");
              console.log(e);
              var friendlyMessage = getFriendlyErrorMessage(e);
              commit("setErrorMessage", friendlyMessage);
              e.friendlyMessage = friendlyMessage;
              reject(e);
            });

          //commit("setProgressMessage", "Ricerca completata");
        },
        error => {
          //console.log("**** error")
          console.log("Errore");
          console.log(error);
          var friendlyMessage = getFriendlyErrorMessage(error);
          commit("setErrorMessage", friendlyMessage);
          if (error && typeof error === "object") {
            error.friendlyMessage = friendlyMessage;
          }
          reject(error);
        }
      );
    },
    async checkSession({ state, commit, rootState, dispatch }, params) {
      var self = this;

      return new Promise(
        (resolve, reject) => {
          //commit("setProgressMessage", "Ricerca in corso");
          //var urlPostRequest = Conf.idempiereUrl + "/checkSession";
          var urlPostRequest = Conf.idempiereUrl + 
            "webservices/rest/v1/auth/checkActiveSession";

          //console.log("urlPostRequest");
          //console.log(urlPostRequest);

          //console.log("rootState.uuid >> " + rootState.uuid);

          var parameters = {};
          //parameters.uuid = rootState.uuid;
          parameters.json = JSON.stringify({ ad_session_uu: rootState.uuid });

          axios.defaults.headers["Content-Type"] =
            "application/json;charset=utf-8";
          axios
            .post(
              urlPostRequest,
              JSON.stringify(parameters), // the data to post
              {
                headers: {
                  "Content-type": "application/json;charset=utf-8"
                }
              }
            )
            .then(response => {
              if (response.data.errorCode == 1) {
                router.push({ path: "/Login/" });
              }
              resolve(response);
            })
            .catch(e => {
              console.log("Eccezione");
              console.log(e);
              e.friendlyMessage = getFriendlyErrorMessage(e, "Errore durante il controllo della sessione");
              reject(e);
              //this.errors.push(e)
            });

          //commit("setProgressMessage", "Ricerca completata");
        },
        error => {
          //console.log("**** error")
          console.log("Errore");
          console.log(error);
          //state.commit("setErrorMessage", error);
          reject(error);
        }
      );
    }
  },
  getters: {
    currentState: state => state.currentState,
    //stampaLI_DOTes: state => state.stampaLI_DOTes,
    //stampaLI_Saved: state => state.stampaLI_Saved,
    errorMessage: state => state.errorMessage,
    progressMessage: state => state.progressMessage,
    dialogMessage: state => state.dialogMessage,
    breadcrumbItems: state => state.breadcrumbItems,
    lottoInterno: state => state.lottoInterno,
    progressLoading: state => state.progressLoading,
    abilitatazioneModificaOre:state => state.abilitatazioneModificaOre
  }
});
